export default "__VITE_ASSET__o9bA8YXY__"